<template>
	<div class="ui segment">
		<div class="ui top attached label">
			<i class="calendar check outline icon"></i> Temporal extent :</div>
		<div><b>Temporal extent</b>: From {{temporalExtent.dateBeg}} to {{temporalExtent.dateEnd}} </div>
	</div>
</template>

<script>
export default {
	props:["temporalExtent"]
}
</script>

<style>

</style>
